/* ============================================================
   TREVANI — comportamenti store

   Contiene:
   1. Selettore lettera A-Z (homepage + PDP) — seleziona la variante reale
   2. Sticky add-to-cart mobile
   3. Rassicurazioni nel carrello a tendina
   ============================================================ */
(function () {
  'use strict';

  // Lo snippet trevani-assets è incluso da ogni sezione, quindi questo file
  // può comparire più volte nella pagina. Senza guard i listener si
  // moltiplicherebbero e ogni click verrebbe gestito N volte.
  if (window.__trevaniInit) return;
  window.__trevaniInit = true;

  /* ---------- 1. SELETTORE LETTERA ---------- */
  function initLetterPickers(root) {
    var groups = (root || document).querySelectorAll('[data-trv-letters]');

    Array.prototype.forEach.call(groups, function (group) {
      // il form che contiene il selettore: input nascosto, output, prezzo
      var scope = group.closest('form') || group.parentNode;
      var input = scope.querySelector('[data-trv-variant-input]');
      var out = scope.querySelector('[data-trv-letter-out]');
      var priceEl = scope.querySelector('[data-trv-price]');

      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.trv-letter');
        if (!btn || btn.disabled || !group.contains(btn)) return;

        Array.prototype.forEach.call(group.querySelectorAll('.trv-letter'), function (b) {
          b.classList.remove('is-sel');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-sel');
        btn.setAttribute('aria-pressed', 'true');

        if (input) input.value = btn.dataset.variantId;
        if (out) out.textContent = btn.dataset.variantLabel;
        if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;

        // tiene allineato l'URL: ricaricando la pagina resta la lettera scelta
        if (window.history && window.history.replaceState && document.body.classList.contains('template-product')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', btn.dataset.variantId);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  /* ---------- 2. STICKY ADD-TO-CART MOBILE ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('.trv-sticky-atc');
    if (!bar) return;

    // riferimento: il pulsante di acquisto principale della PDP
    var anchor = document.querySelector('[data-trv-atc-anchor]') ||
                 document.querySelector('.product-form__submit');
    if (!anchor) return;

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-on');
      return;
    }

    // la barra compare quando il pulsante principale esce dallo schermo
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -40px 0px' });

    io.observe(anchor);
  }

  /* ---------- 3. CARRELLO A TENDINA: rassicurazioni ----------
     Dawn stampa "Spese di spedizione calcolate al check-out", che contraddice
     il "spedizione gratuita" ripetuto su tutto lo store: e' l'ultima cosa che
     il cliente legge prima di pagare. Qui la nota viene sostituita e sopra il
     pulsante compaiono le rassicurazioni.

     Perche' in JS e non nel Liquid: snippets/cart-drawer.liquid e' un file
     Dawn da 30 KB e riscriverlo per tre righe complica ogni aggiornamento
     futuro del tema. Shopify rimpiazza l'HTML del drawer a ogni modifica del
     carrello, quindi serve un MutationObserver per rimettere il blocco.
  ---------------------------------------------------------------- */
  var VOCI = [
    ['Spedizione gratuita', 'su ogni ordine, senza minimo'],
    ['8-13 giorni lavorativi', 'con tracking, dazi già inclusi nel prezzo'],
    ['30 giorni per cambiare idea', 'spedizione di reso a carico del cliente']
  ];

  function rassicuraCarrello() {
    var footer = document.querySelector('.drawer__footer');
    if (!footer || footer.querySelector('.trv-cart-trust')) return;

    // la nota di Dawn sulla spedizione calcolata al checkout non e' vera da noi
    var nota = footer.querySelector('.tax-note');
    if (nota) nota.textContent = 'Spedizione gratuita, già inclusa. Tasse e dazi compresi nel prezzo.';

    var box = document.createElement('div');
    box.className = 'trv trv-cart-trust';
    var html = '<div class="trv-why">';
    for (var i = 0; i < VOCI.length; i++) {
      html += '<div class="trv-why__r"><i>✓</i> <span><strong>' +
              VOCI[i][0] + '</strong> — ' + VOCI[i][1] + '</span></div>';
    }
    box.innerHTML = html + '</div>';

    var ctas = footer.querySelector('.cart__ctas');
    if (ctas) footer.insertBefore(box, ctas);
  }

  function osservaCarrello() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    rassicuraCarrello();
    new MutationObserver(function () { rassicuraCarrello(); })
      .observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    initLetterPickers(document);
    initStickyAtc();
    osservaCarrello();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // il theme editor rimonta le sezioni: vanno riagganciate
  document.addEventListener('shopify:section:load', function (e) {
    initLetterPickers(e.target);
    initStickyAtc();
  });
})();
